import styled, { css } from 'styled-components'

export const Label = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-200);

  line-height: var(--font-line-height-400);
  color: var(--text-primary);
`

export const Preview = styled.div<{
  $withBorder: boolean
}>(
  ({ $withBorder }) => css`
    position: relative;
    width: 100%;
    height: 100%;

    border: 1px solid ${$withBorder ? 'var(--border-secondary)' : 'transparent'};
  `,
)

export const PreviewContainer = styled.div`
  position: relative;
  margin-bottom: var(--space-200);

  cursor: pointer;
`

export const Value = styled.div`
  font-size: var(--font-size-200);
`

export const Container = styled.div`
  display: flex;
  gap: var(--space-450);

  ${PreviewContainer} {
    width: 56px;
    height: 40px;
    margin-bottom: 0;
  }

  ${Preview} {
    width: 56px;
    height: 40px;
  }
`
